import { resolutions_reverse_template, getNewMsg } from "./param"
import {socketInstanceNew} from "./getSocket"
socketInstanceNew?.on('kline_message', onMessage)

const channelToSubscription = new Map();

async function onMessage(evt) {
	const data = evt;
	if(!data || data.ping) {
		// console.log('[socket] Message333:', data);
		return
	}
	if (data.channel != "kline") {
		// console.log('这里需监听kline通道的数据');
		return
	}
	const tradeTime = parseInt(data.ts);
	let kType = data.kType
	// 0~ethusdt_#_1
	const channelString = `0~${data.symbol}_#_${resolutions_reverse_template[kType]}`;
	const subscriptionItem = channelToSubscription.get(channelString);
	if (subscriptionItem === undefined) {
		return;
	}
	// console.log("kline_close-tick=", data.tick.close)
	let bar;
	bar = {
		time: parseInt(data.tick.ts*1000),
		open: data.tick.open,
		high: data.tick.high,
		low: data.tick.low,
		close: data.tick.close,
	};
	subscriptionItem.lastDailyBar = bar;
	subscriptionItem.handlers.forEach(handler => handler.callback(bar));
}
function sendMessage(data) {
		if (socketInstanceNew.checkOpen()) {
			socketInstanceNew.send(data)
		} else {
			socketInstanceNew.on('open', function() {
				socketInstanceNew.send(data)
			})
		}
}
function getNextDailyBarTime(barTime) {
	const date = new Date(barTime * 1000);
	date.setDate(date.getDate() + 1);
	return date.getTime() / 1000;
}

export function subscribeOnStream(
	symbolInfo,
	resolution,
	onRealtimeCallback,
	subscribeUID,
	onResetCacheNeededCallback,
	lastDailyBar,
) {
	// console.log("symbolInfo=", symbolInfo)
	// ethusdt_#_1
	// console.log("[subscribeBars]: Subscribe to streaming. subscribeUID=", subscribeUID)
	// const channelString = `0~${symbolInfo.full_name}~${subscribeUID}`;
	// const channelString = `0~${symbolInfo.full_name}`;
	// 0~ethusdt_#_1
	const channelString = `0~${subscribeUID}`;
	// console.log("subscribeOnStream-channelString=", channelString)
	const handler = {
		id: subscribeUID,
		callback: onRealtimeCallback,
	};
	// console.log('[subscribeBars]: Subscribe to streaming. Channel:', channelString);
	// console.log('[subscribeBars]: Subscribe to streaming. channelToSubscription:', channelToSubscription);
	let subscriptionItem = channelToSubscription.get(channelString);
	// console.log('[subscribeBars]: Subscribe to streaming. subscriptionItem:', subscriptionItem);
	if (subscriptionItem) {
		subscriptionItem.handlers.push(handler);
		return;
	}
	subscriptionItem = {
		subscribeUID,
		resolution,
		lastDailyBar,
		handlers: [handler],
	};
	// console.log('[subscribeBars]: Subscribe to streaming. subscriptionItem2:', subscriptionItem);
	channelToSubscription.set(channelString, subscriptionItem);
	let msg_str = getNewMsg(symbolInfo.name, resolution,'sub')
	// console.log("subscribeOnStream msg_str=", msg_str)
	// socket?.send(msg_str);
	// 缓存最新订阅的参数
	localStorage.setItem("lastSubMsg", msg_str)
	sendMessage(msg_str)
}

export function unsubscribeFromStream(subscriberUID) {
	// console.log("unsubscribeFromStream subscriberUID=", subscriberUID)
	// console.log("channelToSubscription=", channelToSubscription)
	for (const channelString of channelToSubscription.keys()) {
		const subscriptionItem = channelToSubscription.get(channelString);
		const handlerIndex = subscriptionItem.handlers
			.findIndex(handler => handler.id === subscriberUID);
		if (handlerIndex !== -1) {
			let t = subscriptionItem.handlers.splice(handlerIndex, 1);
			if (subscriptionItem.handlers.length === 0) {
				// console.log('[unsubscribeBars]: Unsubscribe from streaming. Channel:', channelString);
				let arr = t[0].id.split("_#_")
				let msg_str = getNewMsg(arr[0], arr[1],'unsub')
				// console.log("unsubscribeFromStream msg_str=", msg_str)
				// socket?.send(msg_str);
				sendMessage(msg_str)
				channelToSubscription.delete(channelString);
				break;
			}
		}
	}
}
